import React from "react";
import { Paper, Typography } from "@mui/material";
import { ADMIN_METRIC_SX } from "./adminStyles";

const AdminMetric = ({ label, value, hint }) => (
  <Paper variant="outlined" sx={ADMIN_METRIC_SX}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="h4" fontWeight={800} sx={{ mt: 0.5 }}>
      {value}
    </Typography>
    {hint ? (
      <Typography variant="caption" color="text.secondary">
        {hint}
      </Typography>
    ) : null}
  </Paper>
);

export default AdminMetric;
